import { useNotificationModal } from '@room-match/shared-ui-components';
import { useCallback } from 'react';
import { MaxSizeFileType } from 'shared/constants/MAX_SIZE';
import { sizeLimitValue } from 'shared/hooks/sizeLimitValue';

export const useModalValidation = (type: MaxSizeFileType) => {
  const { isOpen, NotificationModal, handleOpen, handleSetMessage } = useNotificationModal({ type: 'error' });
  const handleInvalidFilesMessage = useCallback(() => {
    const limit = sizeLimitValue(type);
    handleSetMessage(
      'Limit Reached',
      `Some file you’re trying to upload exceeds our ${limit} file size limit. We recommend you to either trim down or compress the file.`,
      'Close',
    );
    handleOpen();
  }, []);

  return { isOpen, NotificationModal, handleInvalidFilesMessage };
};
